module.exports = __webpack_public_path__ + "static/media/bulbguardcam-3.a4136a21.jpg";